module.exports = __webpack_public_path__ + "12-o2.gif?56c2a6e9c1b7424dcac9bfa67e98c995";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/12-o2.gif
// module id = 623
// module chunks = 0